import { z } from 'zod'

const MINUTOS_MAXIMOS = 23 * 60 + 59

/** Converte tempo `HH:mm` (formato usado pela API) em minutos */
export function tempoParaMinutos(valor: string | number) {
    if (typeof valor === 'number') return valor

    const texto = valor.trim()
    if (!texto) return 0

    if (!texto.includes(':')) return Number(texto)

    const [horas, minutos] = texto.split(':')
    return Number(horas || 0) * 60 + Number(minutos || 0)
}

function minutosParaTempo(minutos: number) {
    const horas = String(Math.floor(minutos / 60)).padStart(2, '0')
    return `${horas}:${String(minutos % 60).padStart(2, '0')}`
}

/** Campo preenchido em minutos pelo usuário, enviado ao back-end como `HH:mm` */
export const minutosInput = z
    .union([
        z.number(),
        z.string().regex(/^\d*$/, 'Informe a tolerância em minutos'),
    ])
    .nullish()
    .transform(valor =>
        typeof valor === 'string' ? Number(valor || 0) : (valor ?? 0),
    )
    .refine(
        minutos =>
            Number.isInteger(minutos) &&
            minutos >= 0 &&
            minutos <= MINUTOS_MAXIMOS,
        `Tolerância deve ser um valor entre 0 e ${MINUTOS_MAXIMOS} minutos`,
    )
    .transform(minutosParaTempo)

export const toleranciasSchema = z.object({
    entradaAntes: minutosInput,
    entradaDepois: minutosInput,
    saidaAntes: minutosInput,
    saidaDepois: minutosInput,
    toleranciaTurno: minutosInput,
    toleranciaDia: minutosInput,
})

/** Converte as tolerâncias vindas da API (`HH:mm`) para os minutos exibidos no formulário */
export function toleranciasEmMinutos(
    tolerancias: z.output<typeof toleranciasSchema>,
) {
    return Object.fromEntries(
        Object.entries(tolerancias).map(([campo, valor]) => [
            campo,
            tempoParaMinutos(valor),
        ]),
    ) as Record<keyof z.output<typeof toleranciasSchema>, number>
}
